(function () {
  var UTILS_URL = 'https://cdn.jsdelivr.net/npm/intl-tel-input@23.9.3/build/js/utils.js';
  var DEFAULT_COUNTRY = 'pk';
  var SELECTOR = 'input.fiabila-phone-input[type="tel"]';

  function normalizeInternationalValue(value) {
    var trimmed = (value || '').trim();
    if (!trimmed) return '';
    if (trimmed.indexOf('00') === 0) return '+' + trimmed.slice(2);
    return trimmed;
  }

  function syncCountryFromValue(input, iti) {
    var normalized = normalizeInternationalValue(input.value);
    if (!normalized || normalized.indexOf('+') !== 0) return;

    var current = iti.getNumber() || '';
    if (current === normalized) return;

    iti.setNumber(normalized);
  }

  function bindFormSubmit(input, iti) {
    var form = input.closest('form');
    if (!form || form.dataset.fiabilaPhoneSubmitBound === 'true') return;

    form.addEventListener('submit', function () {
      form.querySelectorAll(SELECTOR).forEach(function (phoneInput) {
        var instance = phoneInput._fiabilaIti;
        if (!instance) return;

        var fullNumber = instance.getNumber();
        if (fullNumber) {
          phoneInput.value = fullNumber;
        }
      });
    });

    form.dataset.fiabilaPhoneSubmitBound = 'true';
  }

  function initPhoneInput(input) {
    if (!window.intlTelInput || input.dataset.fiabilaPhoneReady === 'true') return;

    var iti = window.intlTelInput(input, {
      initialCountry: DEFAULT_COUNTRY,
      preferredCountries: ['pk', 'ae', 'sa', 'gb', 'us', 'ca'],
      separateDialCode: true,
      nationalMode: true,
      autoPlaceholder: 'aggressive',
      formatOnDisplay: true,
      utilsScript: UTILS_URL
    });

    input.dataset.fiabilaPhoneReady = 'true';
    input._fiabilaIti = iti;

    var initialValue = normalizeInternationalValue(input.value);
    if (initialValue) {
      iti.setNumber(initialValue);
    }

    input.addEventListener('input', function () {
      syncCountryFromValue(input, iti);
    });

    input.addEventListener('paste', function () {
      window.setTimeout(function () {
        syncCountryFromValue(input, iti);
      }, 0);
    });

    input.addEventListener('blur', function () {
      syncCountryFromValue(input, iti);
    });

    bindFormSubmit(input, iti);
  }

  function initAllPhoneInputs() {
    document.querySelectorAll(SELECTOR).forEach(initPhoneInput);
  }

  function boot() {
    if (!window.intlTelInput) {
      window.setTimeout(boot, 100);
      return;
    }

    initAllPhoneInputs();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
